import {
  LOAD_ALL_SURVEYS_REQUEST,
  LOAD_ALL_SURVEYS_SUCCESS,
  LOAD_ALL_SURVEYS_FAIL,
  SURVEY_DETAIL_REQUEST,
  SURVEY_DETAIL_SUCCESS,
  SURVEY_DETAIL_FAIL,
  DELETE_SURVEY_REQUEST,
  DELETE_SURVEY_SUCCESS,
  DELETE_SURVEY_FAIL,
  CLEAR_ERRORS,
} from "../constants/adminSurveyConstants";

export const surveyListReducer = (state = { surveys: [] }, action) => {
  switch (action.type) {
    case LOAD_ALL_SURVEYS_REQUEST:
      return { user_loading: true, surveys: [] };
    case LOAD_ALL_SURVEYS_SUCCESS:
      return { user_loading: false, surveys: action.payload.data };
    case LOAD_ALL_SURVEYS_FAIL:
      return { user_loading: false, error: action.payload };
    case CLEAR_ERRORS:
      return { ...state, error: null };
    default:
      return state;
  }
};

export const surveyDetailReducer = (state = { survey: {} }, action) => {
  switch (action.type) {
    case SURVEY_DETAIL_REQUEST:
      return { user_loading: true, survey: {} };
    case SURVEY_DETAIL_SUCCESS:
      return { user_loading: false, survey: action.payload };
    case SURVEY_DETAIL_FAIL:
      return { user_loading: false, error: action.payload };
    case CLEAR_ERRORS:
      return { ...state, error: null };
    default:
      return state;
  }
};

export const deleteSurveyReducer = (state = {}, action) => {
  switch (action.type) {
    case DELETE_SURVEY_REQUEST:
      return { user_loading: true };
    case DELETE_SURVEY_SUCCESS:
      return { user_loading: false, deletedId: action.payload };
    case DELETE_SURVEY_FAIL:
      return { user_loading: false, error: action.payload };
    default:
      return state;
  }
};
